import Log from '../components/Log/Log.vue'

let routes = {
    path: '/indicators',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/admin/logs',
            name: 'Logs',
            component: Log
        }
    ]
}


export default routes



// WEBPACK FOOTER //
// ./src/router/log.js